import React from "react";
import values from "../../values";
import Context from "../../context";
import Components from "./Components";

import {
  BreadCrumb,
  CustomView,
  Pagination,
  TableHeader,
  TableLoading,
} from "../../components";

import "./index.sass";
import utils from "../../utils";
import Cookies from "js-cookie";
import constants from "../../values/constants";
import { useTranslation } from "react-i18next";

type Props = {
  rqAbsent: any;
  role: "ADMIN" | "SUPER_AGENT_SCHOOL";
};

const CompanyScreen = (props: Props) => {
  const userType = utils.stringHexConversion.reverse(
    Cookies.get(constants.USER.TYPE)
  );
  const { data, status } = props.rqAbsent;
  const { requestAbsent, setRequestAbsent } = React.useContext(
    Context.AbsentScreen
  );

  const { t } = useTranslation();

  return (
    <>
      <CustomView.Container id="company-screen-container">
        <CustomView.Row className="table-options-wrapper">
          <CustomView.Column
            extraLarge={3}
            large={5}
            medium={5}
            className="bread-crumb-wrapper"
          >
            <BreadCrumb />
          </CustomView.Column>
          <CustomView.Column
            extraLarge={4}
            large={5}
            medium={7}
            className="search-and-filter-wrapper"
          >
            <Components.Filter />
            {/* <Components.Search /> */}
          </CustomView.Column>
        </CustomView.Row>
        <div className="table-content-wrapper">
          <table>
            <TableHeader
              headers={values.tableHeaders.ABSENT_HEADERS.map((item) =>
                t(item)
              )}
            />
            {status === "loading" ? (
              <TableLoading />
            ) : (
              <Components.Body data={data?.result?.docs} />
            )}
          </table>
        </div>
        {status === "success" &&
          data?.result?.totalDocs >
            values.constants.PANEL_TABLE_DEFAULT_LIMIT && (
            <div className="pagination">
              <Pagination
                page={requestAbsent?.page}
                totalPages={data?.result?.totalPages}
                onPaginate={(page: number) =>
                  setRequestAbsent({ ...requestAbsent, page })
                }
              />
            </div>
          )}
      </CustomView.Container>
      <Components.Update />
    </>
  );
};

export default CompanyScreen;
